import { IExperienceDenormalized } from '@dadohr/shared/domainTypes/experience';
import styled from '@emotion/styled';
import { ColoredChipLight } from '../../../../../components/ColoredChip';
import { toFullName } from '../../../../../services/user';

const Container = styled('div')((p) => ({
  marginTop: p.theme.spacing(2),
  marginBottom: p.theme.spacing(2)
}));

export const ParticipantInfo = ({ d }: { d: IExperienceDenormalized }) => {
  return (
    <Container>
      <ColoredChipLight color="gray">
        {toFullName(d.participant)}
      </ColoredChipLight>
    </Container>
  );
};
